import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { classIf, getConfiguration } from '../../data/utils';
import Img from '../Img';
import { getMatchStreamingProps, getStreamingId } from '../../data/streaming/streamingUtils';
import { useStreaming } from '../live-tracker/StreamingProvider';
import Streaming from '../live-tracker/Streaming';
import WidgetWrapper from '../WidgetWrapper';

export default function StreamingToggle(props) {
    const conf = getConfiguration();
    const streaming = useStreaming();

    useEffect(() => {
        window.addEventListener('xs-close-streaming', closeStreaming);

        return () => {
            window.removeEventListener('xs-close-streaming', closeStreaming);
            // streamingContext.toggleStreamingId(null,null,null);
        };
    }, []);

    const match = props.match;
    if (match == null) {
        return null;
    }

    let streamingId = null;
    const streamingMap = getMatchStreamingProps(match);
    if (streamingMap != null) {
        streamingId = getStreamingId(streamingMap[match.id]);
    }

    if (streamingId == null || conf.lstwc) {
        return null;
    }

    function isStreamingOpened() {
        return streaming.streamingId === streamingId;
    }

    function closeStreaming() {
        streaming.toggleStreamingId(null, null, null);
    }

    function toggleStreaming() {
        if (isStreamingOpened()) {
            closeStreaming();
        } else {
            window.dispatchEvent(new CustomEvent('xs-close-live-tracker'));
            streaming.toggleStreamingId(streamingMap[match.id], streamingId, match.id);
        }
    }

    return (
        <>
            <Img className={props.className + classIf(streaming.streamingId != null, 'active')}
                src="icon_liveTV.svg"
                height="32px"
                width="32px"
                onClick={toggleStreaming}
            />
            {streaming.streamingId && ReactDOM.createPortal(
                <WidgetWrapper data={match} close={toggleStreaming}>
                    <Streaming />
                </WidgetWrapper>,
                document.getElementById('xs-live-tracker')
            )}
        </>
    );
}
